import { createContext } from 'react';

export type RuntimeContext = {
    isMobile: boolean;
    collator: Intl.Collator | null;
    modalRoot: HTMLElement;
}

export const RuntimeContext = createContext<RuntimeContext>({
    isMobile: false,
    collator: null,
    modalRoot: document.createElement('div'),
});
